import LayoutConfirmDeletePlaylistScreens from './LayoutConfirmDeletePlaylistScreens';

export default LayoutConfirmDeletePlaylistScreens;
